export default __webpack_public_path__ + "static/1-8-0-0-719550f707bba9c42dd703cdd1deacf6.jpg";